import { darkModeTextColor } from "constants/colors";
import styled from "styled-components/macro";

export const OverallBarstackStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  display: flex;
  flex-grow: 1;
  height: 41px;
  align-items: center;
  cursor: pointer;
  .barstackSpacer {
    height: 45px;
    width: 20px;
    min-width: 20px;
    border-left: 2px solid
      ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
    border-right: 2px solid
      ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
    box-sizing: border-box;
  }
  .pnlBarHorizontal {
    &:hover {
      opacity: 0.5;
    }
    height: 100%;
    box-sizing: border-box;
  }
  .leftStack {
    &:not(.zeroWidth) {
      margin-left: 1px;
    }
    &.first,
    .first {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
  }
  .rightStack {
    &:not(.zeroWidth) {
      margin-right: 1px;
    }
    &.last,
    .last {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
`;
